<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="CVs"
      :items-per-page="10"
      :footer-props="{'items-per-page-text': 'Số Hồ Sơ một trang'}"
      disable-sort
      :server-items-length="count"
      v-bind="this.$attrs"
      :options.sync="pagination"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
      <template v-slot:[`item.code`]="{item}">
        <v-btn
          class="document-btn text-none text-decoration-underline px-0"
          color="primary"
          @click="onDocumentClick(item.id)"
          plain
        >
          {{ item | getCode }}
        </v-btn>
      </template>
      <template v-slot:[`item.department`]="{item}">
        {{ item | getDepartment }}
      </template>
      <template v-slot:[`item.name`]="{item}">
        {{ item | getStudent }}
      </template>
      <template v-slot:[`item.parentPhone`]="{item}">
        {{ item | getUserPhone }}
      </template>
      <template v-slot:[`item.retriedAt`]="{item}">
        {{ item | getRetriedAt }}
      </template>
      <template v-slot:[`item.retriedBy`]="{item}">
        {{ item | getRetriedBy }}
      </template>
      <template v-slot:[`item.retryType`]="{item}">
        {{ item.retryType | getRetryType }}
      </template>
      <template v-slot:[`item.actions`]="{item}">
        <v-menu offset-y v-if="$_get(item, 'retryType', 0) === 2">
          <template v-slot:activator="{on, attrs}">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list class="px-2" dense>
            <v-list-item class="py-1" @click="() => onCancel(item)">
              <v-list-item-content class="red--text">Hoàn tác</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import moment from 'moment'

const BASE_HEADERS = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Học sinh', value: 'name'},
  {text: 'SĐT tài khoản', value: 'parentPhone'},
  {text: 'Loại đăng ký', value: 'retryType'},
  {text: 'Đăng ký lúc', value: 'retriedAt'},
]

export default {
  computed: {
    ...mapGetters('cv', ['CVs', 'count', 'filterParams']),
    ...mapGetters('auth', ['user', 'role']),
    headers() {
      if (get(this.user, 'department', '') === 'both') return [...BASE_HEADERS, {text: 'Thao tác', value: 'actions'}]
      return BASE_HEADERS
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('cv', ['fetchCVs', 'cancelRegisterG6Retry2']),
    getBaseQuery() {
      const query = {adminQueryType: 'g6Retry', fromAdmin: true}
      if (this.user.department === 'both') {
        if (!Object.keys(this.filterParams).includes('department_in'))
          query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
      } else query.department_in = [this.user.department, 'unset']
      if (!this.user.department || this.user.department !== 'both') query.status_ne = 'disabled'

      return query
    },
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchCVs({...this.getBaseQuery(), _start, _limit})
      this.loading = false
    },
    onDocumentClick(documentId) {
      this.$emit('onDocumentDetail', documentId)
    },
    onCancel(item) {
      this.$dialog.confirm({
        title: 'Hoàn tác đăng ký',
        okText: 'Xác nhận',
        topContent: '',
        midContent: `Bạn có chắc chắn muốn hoàn tác đăng ký đối với hồ sơ ${item.code}`,
        botContent: '',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          try {
            await this.cancelRegisterG6Retry2(item.id)
            this.$alert.success(`Hoàn tác đăng ký cho hồ sơ ${item.code} thành công`)
            await this.refresh()
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  filters: {
    getUserPhone: item => get(item, 'parentUsername', '---'),
    getStudent: item => get(item, 'name', '---'),
    getDepartment: item => {
      if (!item.department || item.department === 'unset') return '---'
      else return item.department
    },
    getCode: item => get(item, 'code', '---'),
    getRetriedAt: item => {
      if (item.retryType === 1) return moment(item.createdAt).format('DD/MM/YYYY HH:mm')
      return moment(get(item, 'g6Retry2Transactions.0.transactionTime')).format('DD/MM/YYYY HH:mm')
    },
    // getRetriedBy: item => get(item, 'retriedBy', '---'),
    getRetryType: item => (item === 1 ? 'Đăng ký mới' : 'Chuyển từ đợt 1'),
  },
}
</script>
